export default (superClass) => {
    return class extends superClass {
        get acceptsPaymentRemarks() {
            return this._data.accepts_payment_remarks;
        }
        
        get paymentRemarksMaxCount() {
    
            if (! this.acceptsPaymentRemarks) {
                return 0;
            }
    
            return this._data.payment_remarks_max_count;
        }
    }
}